import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Docs from "@/pages/Docs";
import { Privacy, Terms } from "@/pages/Legal";
import TenXDev from "@/pages/TenXDev";

export default function App() {
  return (
    <div className="min-h-screen bg-[var(--pg-bg)] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/:slug" element={<Docs />} />
          <Route path="/10x-dev" element={<TenXDev />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
